import React, { useContext } from 'react'
import { connect } from 'react-redux'
import { UiContext } from 'context/ui'

import styles from './DashboardRecentCalls.module.scss'

import addWhiteIcon from 'i/icons/add_new.svg'

import { TalksList } from 'components/Talks'
import { TalkListPreview } from 'components/TalkListPreview'
import { FetchResult } from 'components/FetchResult'
import { VideoHelp } from 'components/Dashboard/VideoHelp'

import { useFetchProCalls } from './hook'

import { setCalls, setRequests } from 'store/actions'

import { PROMISE_STATES, POPUPS_ID } from 'utils/constants'

const DashboardRecentCalls = (props) => {
  const { loading, error, previousCalls, previousRecordedCalls } = useFetchProCalls(props)
  const hasPreviousCalls = Array.isArray(previousCalls)
    ? previousCalls.length > 0
    : Boolean(previousCalls)

  const { activePopupId, setActivePopupId } = useContext(UiContext)

  const showPopup = (popupId) => {
    setActivePopupId(popupId)
  }

  return (
    <>
      {!hasPreviousCalls && loading !== PROMISE_STATES.pending && <VideoHelp />}

      {(hasPreviousCalls || loading === PROMISE_STATES.pending) && (
        <div className={styles.DashboardRecentCalls}>
          <>
            <FetchResult
              error={error}
              status={loading}
              data={previousCalls}
              indicator={<TalkListPreview />}
            >
              {hasPreviousCalls && activePopupId !== POPUPS_ID.chat && (
                <div className={styles.DashboardRecentCallsHead}></div>
              )}

              {hasPreviousCalls && (
                <div className={styles.DashboardRecentCallsTalks}>
                  <TalksList
                    calls={previousCalls}
                    recordedCalls={previousRecordedCalls}
                    toggleSidebar={props.toggleSidebar}
                  />
                </div>
              )}

              {!previousCalls && (
                <>
                  <div
                    className="dashboardCreateMeetingWrap"
                    onClick={() => showPopup(POPUPS_ID.sendInvite)}
                  >
                    <div className="createIconWrap">
                      <img src={addWhiteIcon} className="start_icon" alt="" />
                    </div>
                    <div className="startContentWrap">
                      <p>Create first meeting</p>
                    </div>
                  </div>
                  <div className="dashboardCreate_bottom_text">talkpro</div>
                </>
              )}
            </FetchResult>
          </>
        </div>
      )}
    </>
  )
}

const mapStateToProps = ({ auth: { error, isPro, user, calls, requests } }) => ({
  authError: error,
  user,
  isPro,
  calls,
  requests,
})

const willMapDispatchToProps = {
  setRequests,
  setCalls,
}

export default connect(mapStateToProps, willMapDispatchToProps)(DashboardRecentCalls)
